










import Vue from "vue";
import Component from "vue-class-component";
import { authState } from "@/utils/store-acessor";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import AccessibilityMenu from "./components/AccessibilityMenu.vue";

@Component({
  components: { AccessibilityMenu }
})
export default class App extends Vue {
  name: string = "App";
  loading: boolean = false;
  counter: number = 0;

  beforeCreate() {
    authState.alreadyLoggedIn();
  }

  @Watch("$route")
  onRouteUpdate(route: Route) {
    if (route) {
      this.loading = route.name == "home";
    }
  }
}
